module.exports = __webpack_public_path__ + "media/images/star-half-db354705c38d1aa0338d1c6c2700384a.svg";